import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { AppThunk } from '../stores/redux-store';
import { setApplicationError } from '../stores/app-state-store';
import { getErrorMessageFromStatusCode } from '../utilities/error';
import { getSessionFailure, getSessionStart, getSessionSuccess } from '../stores/session-store';
import { SessionModel } from '../models/session';
import { fetchSession } from '../lib-api/services/Session';

export const getSession =
  (sessionId?: string): AppThunk =>
  async (dispatch) => {
    if (!sessionId) {
      return;
    }

    dispatch(getSessionStart());

    const response = await fetchSession(sessionId);

    if (response.isOk()) {
      const sessionFields: SessionModel = response.data.session;
      dispatch(getSessionSuccess(sessionFields));
    } else {
      dispatch(getSessionFailure(getErrorMessageFromStatusCode(response.status)));

      dispatch(
        setApplicationError({
          errorStatus: ErrorStatus.INTERNAL_ERROR,
          errorReason: ErrorReason.REQUEST_FAILED_FETCH_SESSION,
        })
      );
    }
  };
